import Layout from '@/layout/index.vue';
var storeRouter = {
  path: '/lottery',
  component: Layout,
  redirect: '/lottery/list',
  name: 'Lottery',
  meta: {
    title: '彩票管理'
  },
  children: [{
    path: 'list',
    name: 'LotteryList',
    component: function component() {
      return import('@/views/lottery/list/index.vue');
    },
    meta: {
      title: '彩票列表'
    }
  }, {
    path: 'cate',
    name: 'LotteryCate',
    component: function component() {
      return import('@/views/lottery/cate/index.vue');
    },
    meta: {
      title: '彩票分类'
    }
  }, {
    path: 'issue',
    name: 'LotteryIssue',
    component: function component() {
      return import('@/views/lottery/issue/index.vue');
    },
    meta: {
      title: '期次汇总'
    }
  }, {
    path: 'scratch',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryScratch',
    meta: {
      title: '刮刮卡'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/scratch/order/index.vue');
      },
      name: 'LotteryScratchOrder',
      meta: {
        title: '刮刮卡订单'
      }
    }]
  }, {
    path: 'wingo',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryWingo',
    meta: {
      title: 'WinGo'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/wingo/order/index.vue');
      },
      name: 'LotteryWingoOrder',
      meta: {
        title: 'WinGo订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/wingo/issue/index.vue');
      },
      name: 'LotteryWingoIssue',
      meta: {
        title: 'WinGo期次'
      }
    }]
  }, {
    path: 'kerala',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryKerala',
    meta: {
      title: 'Kerala'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/kerala/order/index.vue');
      },
      name: 'LotteryKeralaOrder',
      meta: {
        title: 'Kerala订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/kerala/issue/index.vue');
      },
      name: 'LotteryKeralaIssue',
      meta: {
        title: 'Kerala期次'
      }
    }]
  }, {
    path: 'dear',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryDear',
    meta: {
      title: 'Dear'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/dear/order/index.vue');
      },
      name: 'LotteryDearOrder',
      meta: {
        title: 'Dear订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/dear/issue/index.vue');
      },
      name: 'LotteryDearIssue',
      meta: {
        title: 'Dear期次'
      }
    }]
  }, {
    path: 'matka',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryMatka',
    meta: {
      title: 'Matka'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/matka/order/index.vue');
      },
      name: 'LotteryMatkaOrder',
      meta: {
        title: 'Matka订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/matka/issue/index.vue');
      },
      name: 'LotteryMatkaIssue',
      meta: {
        title: 'Matka期次'
      }
    }]
  }, {
    path: 'pick',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryPick',
    meta: {
      title: 'Pick'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/pick/order/index.vue');
      },
      name: 'LotteryPickOrder',
      meta: {
        title: 'Pick订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/pick/issue/index.vue');
      },
      name: 'LotteryPickIssue',
      meta: {
        title: 'Pick期次'
      }
    }]
  }, {
    path: 'box',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryBox',
    meta: {
      title: 'Box'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/box/order/index.vue');
      },
      name: 'LotteryPickOrder',
      meta: {
        title: 'Box订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/box/issue/index.vue');
      },
      name: 'LotteryPickIssue',
      meta: {
        title: 'Box期次'
      }
    }]
  }, {
    path: 'abc',
    component: function component() {
      return import('@/views/lottery/index.vue');
    },
    name: 'LotteryAbc',
    meta: {
      title: 'Abc'
    },
    children: [{
      path: 'order',
      component: function component() {
        return import('@/views/lottery/abc/order/index.vue');
      },
      name: 'LotteryAbcOrder',
      meta: {
        title: 'Abc订单'
      }
    }, {
      path: 'issue',
      component: function component() {
        return import('@/views/lottery/abc/issue/index.vue');
      },
      name: 'LotteryAbcIssue',
      meta: {
        title: 'Abc期次'
      }
    }]
  }]
};
export default storeRouter;